import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio, RadioGroup
} from '@mui/material';
import { useRecoilState } from 'recoil';
import { cfdModelState } from 'features/optimization/state/cfdConfigAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

const radioSx = {
  color: '#e9e9e9',
  '&.Mui-checked': {
    color: '#1976d2',
  },
  transform: 'scale(.9)',
  padding: '1px',
};

export const CFDModelSelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 5,
}) => {
  const [cfdModel, setCfdModel] = useRecoilState(cfdModelState);

  const handleModelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCfdModel((event.target as HTMLInputElement).value);
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <FormControl >
            <RadioGroup
              row
              aria-labelledby="dmorphing-direction-label"
              name="row-radio-buttons-group"
              value={cfdModel}
              onChange={handleModelChange}
            >
              <FormControlLabel
                value="steady"
                control={<Radio sx={radioSx} />}
                label={<CustomTypography>steady</CustomTypography>}
              />
              <FormControlLabel
                value="unsteady"
                control={<Radio sx={radioSx} />}
                label={<CustomTypography>unsteady</CustomTypography>}
                disabled // TEMPORARY
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};
